module.exports = __webpack_public_path__ + "static/media/service-dots.5a784954.svg";